import { render, staticRenderFns } from "./FormRollQuantity.vue?vue&type=template&id=579445d7&scoped=true"
import script from "./FormRollQuantity.vue?vue&type=script&lang=js"
export * from "./FormRollQuantity.vue?vue&type=script&lang=js"
import style0 from "./FormRollQuantity.vue?vue&type=style&index=0&id=579445d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579445d7",
  null
  
)

/* custom blocks */
import block0 from "./FormRollQuantity.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports